import {http} from '@/helpers/http-helper';

class User {
    constructor(
        uuid,
        username,
        email,
        firstname,
        lastname,
        status,
        roles,
        permissions,
        department,
        headquarters
    ) {
        this.uuid = uuid;
        this.username = username;
        this.email = email;
        this.firstname = firstname;
        this.lastname = lastname;
        this.status = status;
        this.roles = roles;
        this.permissions = permissions;
        this.department = department;
        this.headquarters = headquarters;
    }
}

export const updateUser = (uuid, properties) => {
    return new Promise( (resolve, reject) => {
        const url = 'users/' + uuid;
        http.post(url, properties)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateUserPermissions = (uuid, permissions) => {
    return new Promise( (resolve, reject) => {
        const url = 'user/' + uuid + '/permissions';
        http.post(url, {permissions: permissions})
            .then((response) => {
                if (response.status === 200) {
                    resolve(true);
                } else {
                    reject(false);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getAdvisers = () => {
    return new Promise( (resolve, reject) => {
        const url = 'advisers';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getUsers = () => {
    return new Promise( (resolve, reject) => {
        const url = 'users';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let users = [];
                    response.data.forEach((user) => {
                        users.push(new User(
                            user.uuid,
                            user.username,
                            user.email,
                            user.firstname,
                            user.lastname,
                            user.status,
                            user.roles,
                            user.permissions,
                            user.department,
                            user.headquarters
                        ));
                    });

                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};


export const getPaginatedUsers = (searchData) => {
    return new Promise( (resolve, reject) => {
        const url = 'users-paginated';
        http.post(url, {searchData: searchData})
            .then((response) => {
              
                if (response.status === 200) {

                    let users = [];
                    response.data.users.forEach((user) => {
                        users.push(new User(
                            user.uuid,
                            user.username,
                            user.email,
                            user.firstname,
                            user.lastname,
                            user.status,
                            user.roles,
                            user.permissions,
                            user.department,
                            user.headquarters
                        ));
                    });

                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};